import { FieldType } from "../common/constants";

export const ABOUT_DOC = {
    fields: [
        {
            id: "title",
            type: FieldType.TEXT,
            required: true,
            label: "About.PageTitle",
            localizable: true,
        },
        {
            id: "order",
            type: FieldType.NUMBER,
            required: true,
            label: "About.Order",
        },
        {
            id: "content",
            type: FieldType.HTML,
            required: true,
            label: "About.Content",
            localizable: true,
        },
    ],
};

export const ABOUT_MAIN_DOC = {
    fields: [
        {
            id: "content",
            type: FieldType.HTML,
            required: true,
            label: "HomePage.Content",
            localizable: true,
        },
    ],
};
